<div class="col-12 caption mt-3" *ngIf="isUnitConfig && id">
  <div
    class="d-flex align-items-center"
    *ngIf="isUnitConfigByDay; else noConfigByDay"
  >
    <input
      type="radio"
      class="mr-2"
      style="width: 20px; height: 20px; flex: none; margin: 0px"
      [(ngModel)]="unitValue"
      (ngModelChange)="changeUnit()"
      [name]="'unitValue' + id"
      [value]="'tháng'"
    />
    <span>Tháng</span>

    <input
      type="radio"
      class="ml-4 mr-2"
      style="width: 20px; height: 20px; flex: none; margin: 0px"
      [(ngModel)]="unitValue"
      (ngModelChange)="changeUnit()"
      [name]="'unitValue' + id"
      [value]="'ngày'"
    />
    <span>Ngày</span>
  </div>
  <ng-template #noConfigByDay>
    <div class="d-flex align-items-center">
      <div
        class="d-flex align-items-center mr-4"
        *ngFor="let item of unitValues"
      >
        <input
          type="radio"
          class="mr-2"
          style="width: 20px; height: 20px; flex: none; margin: 0px"
          [(ngModel)]="unitValue"
          (ngModelChange)="changeUnit()"
          [name]="'unitValue' + id"
          [value]="item.code"
        />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </ng-template>
</div>
<div class="col-md-6 m-t-30 mb-3"  [hidden]="!isHasDate">
  <filter-start-end-date 
    id="filterStartEndDate"
    #filterStartEndDate [startDate]="fromDate" [endDate]="toDate"
  ></filter-start-end-date>
</div>

<div class="row">
  <div class="col-11">
    <div class="row">
      <!--fee default-->
      <div class="col-12 form-group">
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-1 no-padding-right">
            <label for=""></label>
            <select
              class="form-control"
              [(ngModel)]="fee.endOperatorCode"
              (ngModelChange)="changeOperator(null, true)"
            >
              <option *ngFor="let item of endOperators" [value]="item.code">
                <label for="" style="font-weight: 600">
                  {{ item.code }}
                </label>
              </option>
            </select>
          </div>
          <div class="col-5 col-md-3 no-padding-right second-fee">
            <label for="">Giá trị</label>
            <div class="input-group d-flex flex-row">
              <input-number  [isDecimal]="true" [unit]="unit"
                [(amount)]="fee.endValue"  (result)="changeValue(null)">
              </input-number>
            </div>
            <span
              class="error-text"
              *ngIf="isValidated && (fee.fee || lastedFee.fee) && !fee.endValue"
            >
              Nhập giá trị
            </span>
          </div>
          <div class="col-2 col-md-2 percent-fee">
            <label for="">Phí</label>
            <div class="input-group d-flex flex-row">
              <input-number  [isDecimal]="true" 
                [(amount)]="fee.fee" unit="%">
              </input-number>
            </div>
            <span
              class="error-text"
              *ngIf="
                isValidated &&
                (fee.endValue || lastedFee.beginValue) &&
                !(fee.fee >= 0)
              "
            >
              Nhập giá trị
            </span>
          </div>
        </div>
      </div>
      <div class="clear-fix"></div>
      <!--fee default 2-->
      <div class="col-12 form-group" *ngFor="let item of fees; index as index">
        <div class="row">
          <div class="col-md-1"></div>
          <div class="col-4 col-md-4 no-padding-right first-fee">
            <div class="row">
              <div class="col-8">
                <label for="">Giá trị</label>
                <div class="input-group">
                  <input-number  [isDecimal]="true" 
                    *ngIf="index === 0; else type1" disabled="true"
                    [(amount)]="fee.endValue" [unit]="unit">
                  </input-number>
                </div>
                <ng-template #type1>
                  <input-number  [isDecimal]="true" 
                    [(amount)]="fees[index - 1].endValue" [unit]="unit" disabled="true">
                  </input-number>
                </ng-template>
              </div>
              <div class="col-4">
                <label for=""></label>
                <select
                  class="form-control"
                  [(ngModel)]="item.beginOperatorCode"
                  disabled
                >
                  <option
                    *ngFor="let operator of beginOperators"
                    [value]="operator.code"
                  >
                    <label for="" style="font-weight: 600">
                      {{ operator.reverseOperator }}
                    </label>
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-4 col-md-4 no-padding-right second-fee">
            <div class="row">
              <div class="col-3">
                <label for=""></label>
                <select
                  class="form-control"
                  [(ngModel)]="item.endOperatorCode"
                  (ngModelChange)="changeOperator(index)"
                >
                  <option
                    *ngFor="let operator of endOperators"
                    [value]="operator.code"
                  >
                    <label for="" style="font-weight: 600">
                      {{ operator.code }}
                    </label>
                  </option>
                </select>
              </div>
              <div class="col-9 d-flex flex-column">
                <label for="">Giá trị</label>
    
                <div class="input-group">
                  <input-number  [isDecimal]="true" 
                    [(amount)]="item.endValue" (result)="changeValue(index)" [unit]="unit">
                  </input-number>
                </div>
                <span
                  class="error-text"
                  *ngIf="isValidated && item.fee && !item.endValue"
                >
                  Nhập giá trị
                </span>
                <span
                  class="error-text"
                  *ngIf="
                    isValidated &&
                    item.endValue >= 0 &&
                    item.endValue <= item.beginValue
                  "
                >
                  Giá trị nhỏ hơn giá trị trước
                </span>
              </div>
            </div>
          </div>
          <div class="col-2 col-md-2 percent-fee">
            <label for="">Phí</label>
            <div class="row">
              <div class="col-10">
                <div class="input-group d-flex flex-row">
                  <input-number  [isDecimal]="true"
                    [(amount)]="item.fee" [unit]="'%'">
                  </input-number>
                </div>
                <span
                  class="error-text"
                  *ngIf="isValidated && item.endValue && !(fee.fee >= 0)"
                >
                  Nhập giá trị
                </span>
              </div>
              <div class="col-2">
                <div class="remove-fee" *ngIf="!isViewed">
                  <button
                    class="btn btn-primary btn-delete_fee"
                    (click)="removeFee(index)"
                    title="Xóa phí"
                  >
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--fee default 3 -->
      <div class="col-12 form-group">
        <div class="row">
          <div class="col-md-5"></div>
          <div class="col-md-1 no-padding-right">
            <label for=""></label>
            <select
              class="form-control"
              [(ngModel)]="lastedFee.beginOperatorCode"
              (ngModelChange)="changeOperator(null)"
            >
              <option *ngFor="let item of beginOperators" [value]="item.code">
                <label for="" style="font-weight: 600">
                  {{ item.code }}
                </label>
              </option>
            </select>
          </div>
          <div class="col-3 col-md-3 second-fee no-padding-right">
            <label for="">Giá trị</label>
            <div class="input-group d-flex flex-column">
              <div class="d-flex">
                <input-number  [isDecimal]="true" 
                    [(amount)]="lastedFee.beginValue" [unit]="unit" [readonly]="true">
                </input-number>
              </div>
              <span
                class="error-text"
                *ngIf="isValidated && fee.beginValue && !lastedFee.beginValue"
              >
                Nhập giá trị
              </span>
              <span
                class="error-text"
                *ngIf="fee.endValue === 0 && lastedFee.beginValue == 0"
              >
                Giá trị khác 0
              </span>
            </div>
          </div>
    
          <div class="col-2 col-md-2 percent-fee d-flex flex-column">
            <label for="">Phí</label>
            <div class="input-group d-flex flex-row">
              <input-number  [isDecimal]="true"
                  [(amount)]="lastedFee.fee" [unit]="'%'">
              </input-number>
            </div>
            <span
              class="error-text"
              *ngIf="isValidated && fee.fee >= 0 && !(lastedFee.fee >= 0)"
            >
              Nhập giá trị
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-1">
    <div class="add-button" *ngIf="!isViewed">
      <div class="form-group mt-3">
        <button (click)="addFee()" class="btn btn-ok btn--green">
          <i nz-icon nzType="plus" nzTheme="outline"></i>
        </button>
      </div>
    </div>
  </div>

</div>

